<template>
    <div class="dropdown-select">
        <button
            class="flex"
            @click="toggleDropdown()"
            @blur="closeDropdown()"
            @keyup="onKeyUp">
            <span class="flex-full">
                {{ selectText }}
            </span>
            <i class="fa fa-caret-down flex-none"></i>
        </button>
        <div :class="dropdownClasses">
            <div
                class="option"
                @mousedown.prevent=""
                @click="selectOption(option)"
                v-for="option in safeOptions">
                {{ option.label }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            options: {
                /**
                 * Can either be an object array or a value array (strings,
                 * numbers, etc). If an object array, the `value` and `label`
                 * can be different. If a value array, the values will be used
                 * as both the value and label.
                 */
                type: Array,
                required: true,
            },
            value: {
                required: true,
            },
            placeholder: {
                type: String,
                default: 'Please select',
            },
        },

        data() {
            return {
                dropdownOpen: false,
            };
        },

        methods: {
            onKeyUp(ev) {
                if (ev.key === 'Escape') {
                    this.closeDropdown();
                }
            },

            selectOption(option) {
                this.$emit('input', option.value);
                this.closeDropdown();
            },

            toggleDropdown() {
                this.dropdownOpen = !this.dropdownOpen;
            },

            closeDropdown() {
                this.dropdownOpen = false;
            },
        },

        computed: {
            safeOptions() {
                return this.options.map(option => {
                    if (typeof option === 'object') {
                        return {
                            value: option.value,
                            label: option.label || option.value,
                        };
                    } else {
                        return {
                            value: option,
                            label: option,
                        };
                    }
                });
            },

            selectText() {
                if (this.value) {
                    for (const option of this.safeOptions) {
                        if (option.value === this.value) {
                            return option.label;
                        }
                    }
                }
                return this.placeholder;
            },

            dropdownClasses() {
                return {
                    dropdown: true,
                    closed: !this.dropdownOpen
                };
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex {
        display: flex;
    }
    .flex-full {
        flex: 1;
    }
    .flex-none {
        flex: 0;
    }

    .dropdown-select {
        height: 40px;
        overflow: visible;
    }

    button {
        background: #363636;
        border: none;
        width: 100%;
        height: 100%;
        text-align: left;
        padding: 10px;
        align-items: center;

        i {
            margin-left: 8px;
            font-size: 16px;
        }
    }

    .dropdown {
        white-space: nowrap;
        overflow: hidden;
        background: #363636;
        border: 1px solid #666;
        z-index: 1;

        &.closed {
            height: 0;
            border-top: none;
            border-bottom: none;
        }
    }

    .option {
        color: #ebebeb;
        cursor: pointer;
        padding: 5px 10px;

        &:hover {
            background-color: #b0b0b0;
            color: #363636;
        }
    }
</style>



// WEBPACK FOOTER //
// index.vue?c5861032